<template>
  <Modal
    :title="title"
    :visible="visibleModal"
    @onCancel="handleCancel"
    @onOk="handleOk"
    type="import"
    :loading="loading"
    :disabled="fileList.length <= 0"
  >
    <a-upload-dragger
      name="file"
      class="upload-dragger"
      :multiple="multiple"
      :beforeUpload="beforeUpload"
      :fileList="fileList"
      :remove="handleRemove"
      :customRequest="() => {}"
      :accept="generateAccept"
      :openFileDialogOnClick="openFileDialogOnClick"
    >
      <div class="upload-dragger-container">
        <img :src="Upload" alt="" />
        <div class="ant-upload-text">Drag & Drop Your File Here</div>
        <div class="ant-upload-text__sub">File Supported: {{ generateFileSupport }}</div>
        <a-row type="flex" align="middle" justify="center" class="upload-dragger-btn" :gutter="[6, 6]">
          <a-col>
            <Button class="btn-dragger btn-upload" @click="handleBrowse">Browse Here</Button>
          </a-col>
          <a-col>
            <Button @click="handleDownloadTemplate" class="btn-dragger btn-download" :loading="loadingDownload"
              >Download Template</Button
            >
          </a-col>
        </a-row>
      </div>
    </a-upload-dragger>
  </Modal>
</template>

<script>
import { Modal, Button } from "@/components";
import { Upload } from "@/assets";
import { FILE_TYPE, validateFile } from "@/utils";
export default {
  name: "ImportModal",
  components: {
    Modal,
    Button,
  },
  props: {
    visibleModal: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Import File: Project Leave",
    },
    accept: {
      type: Array,
      required: true,
      default: function () {
        return [".xlsx"];
      },
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    loadingDownload: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      Upload,
      fileList: [],
      openFileDialogOnClick: false,
      isClicked: false,
    };
  },
  watch: {
    isClicked(newValue) {
      if (newValue) {
        setTimeout(() => {
          this.openFileDialogOnClick = false;
          this.isClicked = false;
        }, 0);
      }
    },
  },
  computed: {
    generateAccept() {
      if (this.accept?.length <= 0) return "";
      return this.accept?.join(", ");
    },
    generateFileSupport() {
      const { accept } = this;
      if (accept?.length <= 0) return "";
      const listFileSupport = [];
      accept?.forEach((type) => {
        if (FILE_TYPE[type]) {
          listFileSupport.push(FILE_TYPE[type]);
        }
      });
      return listFileSupport.join(", ");
    },
  },
  methods: {
    beforeUpload(file) {
      const { multiple } = this;
      if (!multiple) {
        this.fileList = [];
      }
      this.fileList = [];
      const { isValid, message } = validateFile(file, this.accept);
      if (!isValid) {
        this.$toast.error(message);
      } else {
        if (multiple) {
          this.fileList = [...this.fileList, file];
        } else {
          this.fileList = [file];
        }
      }
      return !isValid;
    },
    handleRemove(fileRemove) {
      this.fileList = this.fileList.filter((file) => file.uid !== fileRemove.uid);
    },

    handleDownloadTemplate(e) {
      e.stopPropagation();
      this.$emit("downloadTemplate");
    },
    handleCancel() {
      this.fileList = [];
      this.$emit("onCancel");
    },
    handleOk() {
      if (this.fileList.length <= 0) {
        this.$toast.error("File is required");
        return;
      }
      this.$emit("onImport", this.fileList, ()=> {
        this.fileList = []
      });
    },
    handleBrowse() {
      this.openFileDialogOnClick = true;
      this.isClicked = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-dragger {
  font-size: 24px;
  ::v-deep .ant-upload-drag {
    background: rgba(0, 32, 46, 0.06);
    box-shadow: inset 0px 3px 6px rgba(0, 32, 46, 0.4);
    border-radius: 12px;
    border: none;
    padding: 40px;
  }
  &-container {
    .ant-upload-text {
      color: #29444f;
      font-weight: 600;
      font-size: 23px;
      padding-top: 20px;
    }

    .ant-upload-text__sub {
      color: #29444f;
      font-weight: 400;
      font-size: 14px;
    }
  }
  &-btn {
    padding-top: 30px;
    .btn-dragger {
      width: 205px;
      font-size: 14px;
      font-weight: 500;
      border-radius: 6px;
      padding: 6px 12px;
      &.btn-upload {
        color: #fff;
        background: rgba(0, 32, 46, 0.92);
      }
      &.btn-download {
        color: #29444f;
        background: rgba(0, 32, 46, 0.06);
      }
    }
  }
}
</style>
